export enum NotFoundType {
  GENERAL = "general",
  PRODUCT = "p",
  CATEGORY = "cat",
  BRAND = "brand",
  SERIES = "series",
  JOB = "jobs"
}
